<template>
  <div class="card-ticket-module">
    <div class="cardList">
      <el-menu default-active="/home/card-ticket-module" class="card-menu" mode="horizontal" @select="handleSelect">
        <el-menu-item index="/home/card-ticket-module">卡券模板</el-menu-item>
        <el-menu-item index="/home/card-ticket-grantDetails">发放明细</el-menu-item>
        <el-menu-item index="/home/card-ticket-hxoff">核销明细</el-menu-item>
      </el-menu>
    </div>

    <div class="sxList">
      <el-row class="search-title">
        <el-col :span="4" class="search-nav-left">
          <i class="el-icon-search" style="font-weight: bold;"></i>
          <span class="order-list-search-span">筛选查询</span>
        </el-col>
        <el-col :span="20" class="search-nav-right">
          <el-button class="search-open-close" type="text" @click="hide=!hide" v-show="hide">收起查询</el-button>
          <el-button class="search-open-close" type="text" @click="hide=!hide" v-show="!hide">展开查询</el-button>
          <i v-if="hide === true" class="el-icon-arrow-up search-open-close-i" @click="hide=!hide"></i>
          <i v-if="hide === false" class="el-icon-arrow-down search-open-close-i" @click="hide=!hide"></i>
          <el-button class="search-btn-new" type="primary" size="small" @click="searchData">查询</el-button>
        </el-col>
      </el-row>
      <el-collapse-transition>
        <div v-show="hide" class="search-flod-content search-content search-input-group common-search-formtype" style="padding: 0;border: none">
          <el-form :inline="true" :model="selectList" class="search-content-item">
            <el-form-item label="模板名称：">
              <el-input v-model="selectList.moduleName" clearable placeholder="请输入模板名称"></el-input>
            </el-form-item>
            <el-form-item label="卡券类型：">
              <el-select filterable v-model="selectList.ticketType" placeholder="请选择卡券类型"
                         @visible-change="visibleChangeOne" @focus="focusWayOne" ref="selectOne">
                <el-option v-for="item in cardticketType" :key="item.value" :label="item.name" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="状态：">
              <el-select v-model="status" placeholder="请选择状态">
                <el-option v-for="(item,index) in statuses" :key="index" :label="item.name" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
      </el-collapse-transition>
    </div>
    <div class="cardTicketModule-list-tltle">
      <el-row class="" style="padding-right:0">
        <el-col :span="4" style="text-align: left;padding-left:20px">
          <i class="el-icon-document" style="font-weight: bold;"></i>
          <span class="order-list-search-span">卡券模板列表</span>
        </el-col>
        <el-col :span="20" class="text-align-right">
          <el-button type="primary" @click="addOfflineAcivityAction" class="add-btn btn-right" style="float: right;">新建</el-button>
        </el-col>
      </el-row>
    </div>
    <div class="cardTicketModule-list">
      <!-- v-loading="loadList" -->
      <el-table class="cardTicketModule-table" :data="tableData" border v-loading="loading">
        <template slot="empty">
          <div class="newTableEmpty">暂无数据，去<span @click="addOfflineAcivityAction">新建</span></div>
        </template>
        <el-table-column label="模板名称">
          <template scope="scope">
            <span class="lookDetails" @click="toAudDetail(scope.row)">{{scope.row.ticketName}}</span>
          </template>
        </el-table-column>
        <el-table-column label="卡券类型">
          <template scope="scope">
            <span v-if="scope.row.ticketType == 1">实物兑换券</span>
            <span v-if="scope.row.ticketType == 2">活动券</span>
            <span v-if="scope.row.ticketType == 3">代金券</span>
          </template>
        </el-table-column>
        <el-table-column prop="discountContent" label="优惠内容">
        </el-table-column>
        <el-table-column :sortable="isSort" label="已领取" prop="receivedQty">
          <template scope="scope">
            <div @click="jupmMx(scope.row)" class="jumpHove">{{scope.row.receivedQty}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="verifiedQty" :sortable="isSort" label="已核销">
          <template scope="scope">
            <div @click="jupmHx(scope.row)" class="jumpHove">{{scope.row.verifiedQty}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="stateStr" label="状态">
          <template scope="scope">
            <div v-if="scope.row.stateStr === '已禁用'"><span class="pointRed"></span>{{scope.row.stateStr}}</div>
            <div v-else-if="scope.row.stateStr === '进行中'"><span class="pointGreen"></span>{{scope.row.stateStr}}</div>
            <div v-else><span class="pointGray"></span>{{scope.row.stateStr}}</div>
          </template>
        </el-table-column>
        <el-table-column class="aud-operatopn-div" fixed="right" label="操作" width="160">
          <template scope="scope">
            <!-- <span class="op-link"
                  v-if="scope.row.stateStr == '已结束'"
                  @click="toAudDetail(scope.row)"
                  size="small">查看</span> -->
            <span class="op-link editColor" v-if="scope.row.stateStr == '进行中' || scope.row.stateStr == '已禁用' || scope.row.stateStr == '已结束' || scope.row.stateStr == '未开始'" v-show="btnType.edit" @click="toEditDetail(scope.row)" size="small">编辑</span>
            <span class="op-link" v-if="scope.row.stateStr == '已禁用' " @click="isenableItem(scope.row.id,'enable')" v-show="btnType.status_change" size="small">启用</span>
            <span class="op-link" v-if="scope.row.stateStr == '进行中' || scope.row.stateStr == '未开始' " @click="isenableItem(scope.row.id,'enabled')" v-show="btnType.status_change" size="small">禁用</span>
            <span class="op-link deleteColor" v-if="scope.row.stateStr == '已结束'" @click="isenableItem(scope.row.id,'del')" v-show="btnType.del" size="small">删除</span>
          </template>
        </el-table-column>
      </el-table>
      <div class="cardTicket-page">
        <el-pagination class="cardTicket-pagination" background @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-size="dataList.page.limit" :current-page="dataList.page.page" layout="total, prev, pager, next, jumper" :total="totalCount">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import { cardList, delTemplate } from '@/api/cardTicket.js'
import { CAR_TICKET_TYPE } from './constant'
import { butonsList,getMenId } from '@/api/analyse.js'
export default {
  name: 'cardTicketModule',
  data () {
    return {
      inputFlagOne: null,
      hide: true,
      selectList: {},
      status: '',
      cardticketType: CAR_TICKET_TYPE,
      statuses: [{
        value: 9,
        name: '全部'
      }, {
        value: 1,
        name: '进行中'
      }, {
        value: 2,
        name: '已结束'
      }, {
        value: 3,
        name: '未开始'
      }, {
        value: 0,
        name: '已禁用'
      },],
      timePickerDate: '',
      tableData: [
      ],
      isSort: true,
      totalCount: 0,//总条目数
      dataList: {
        'ticketName': '',
        'queryState': '',
        'page': {
          'limit': 10,//每页显示的条数
          'page': 1,//当前页数
        }
      },
      loading: true,
      czdata: {},
      btnType:{
        'add':false,
        'edit':false,
        'status_change':false
      }
    }
  },
  methods: {
    focusWayOne () {
      if (this.inputFlagOne) {
        this.$refs['selectOne'].blur()
      }
    },
    visibleChangeOne (val) {
      setTimeout(()=> {
        this.inputFlagOne = val
      },0)
    },
    //模板列表
    getData () {
      this.loading = true
      cardList(this.dataList).then(res => {
        this.tableData = res.data.result.list
        this.totalCount = res.data.result.total
        this.openLoading()
      })
    },
    queryBtnList(){
      var itemId = getMenId(this.$route.path)
       butonsList({systemCode: 'ZY_INTELLIQUOR',menuId:itemId})
        .then((res)=>{
          if(res.data.code == '200'){
            var btnList = this.btnType
            for(let i = 0, k = res.data.result.length; i < k; i ++){
              for(let m in btnList){
                if(res.data.result[i].perms.indexOf(m) != -1){
                  this.btnType[m] = true
                }
              }
            }
          }
        })
    },
    // 数据加载时的动画
    openLoading () {
      setTimeout(() => {
        this.loading = false
      }, 500)
    },
    // 列表的操作
    czFunction () {
      let _this = this
      delTemplate(this.czdata).then(res => {
        if (res.data.code === '200') {
          _this.getData()
          _g.toastMsg('success', res.data.message)
        } else {
          _g.toastMsg('error', res.data.message)
        }
      })
    },
    // 判断启用、禁用、删除
    isenableItem (id, type) {
      this.czdata.id = id
      if (type == 'enable') {
        this.$confirm('确认启用该卡券模板?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.czdata.operate = 'enable'
          this.czFunction()
        })

      } else if (type == 'enabled') {
        this.$confirm('确认禁用该卡券模板?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.czdata.operate = 'disable'
          this.czFunction()
        })

      } else {
        this.czdata.operate = 'delete'
        this.$confirm('确认删除该模板吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            this.czFunction()
          })
          .catch(error => {
            console.log(error)
          })
      }
    },
    //查询
    searchData () {
      this.dataList.ticketName = this.selectList.moduleName
      this.dataList.ticketType = this.selectList.ticketType
      this.dataList.queryState = this.status
      if (this.dataList.queryState == 9) {
        this.dataList.queryState = ''
      }
      if (this.selectList.ticketType == 0) {
        this.dataList.ticketType = ''
      }
      this.getData()
    },
    //跳转到新建卡券模板页面
    addOfflineAcivityAction () {
      router.push({
        path: '/home/card-ticket-new'
      })
    },
    //跳转到编辑卡券模板页面
    toEditDetail (val) {
      router.push({
        path: '/home/card-ticket-edit',
        query: {
          id: val.id
        }
      })
    },
    //跳转到查看卡券模板页面
    toAudDetail (val) {
      router.push({
        path: '/home/card-ticket-see',
        query: {
          id: val.id
        }
      })
    },
    //顶部子菜单的切换
    handleSelect (key, keyPath) {
      router.push(key)
    },
    // 跳转发放明细页面
    jupmMx (val) {
      router.push({
        path: '/home/card-ticket-grantDetails',
        query: {
          templateId: val.id,
          ticketName: val.ticketName
        }
      })
    },
    // 跳转核销明细页面
    jupmHx (val) {
      router.push({
        path: '/home/card-ticket-hxoff',
        query: {
          templateId: val.id,
          ticketName: val.ticketName
        }
      })
    },
    // 处理分页
    handleSizeChange (val) {
      this.dataList.page.limit = val
    },
    handleCurrentChange (page) {
      this.dataList.page.page = page
      this.getData()
    },
  },
  mounted () {
    this.getData()
    this.queryBtnList()
  }
}
</script>

<style scoped>
.lookDetails {
  cursor: pointer;
  color: #1980ff;
}
</style>
